import WrapperService from "@/modules/core/services/wrapper-service";

const API_URL = process.env.VUE_APP_ROOT_API + "/api/v1/process/step/answer"

const serviceName = "ProcessAnswer-Service: ";

export default class ProcessAnswerService {

  static async readAllFromAPI(successF, errorF) {
    await WrapperService.get(API_URL, null, serviceName, successF, errorF);
  }

  static acceptAnswer(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/accept", null, serviceName, successF, errorF);
  }

  static rejectAnswer(id, successF, errorF) {
    WrapperService.put(API_URL + "/" + id + "/reject", null, serviceName, successF, errorF);
  }
}
